module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.00013","quantity":0},{"color":"#9dc4b5","label":" 0.00013- 0.31724","quantity":0.00317},{"color":"#e6efc3","label":" 0.31724- 0.72178","quantity":0.00722},{"color":"#ffe89e","label":" 0.72178- 1.5619","quantity":0.01562},{"color":"#f5af7f","label":" 1.5619- 3.11632","quantity":0.03116},{"color":"#ed6d32","label":" 3.11632- 18.87123","quantity":0.18871}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_90.json
// module id = WYL4
// module chunks = 171